import { configs } from '@constants/configs/configs';
import { SIDENAV_LINKS_TYPES } from '../constants/sideNavLinkTypes';

const {
    routes,
    endpoints,
    states : {
        PENNSYLVANIA,
        NEVADA,
        NEW_JERSEY,
        NEW_MEXICO,
        OREGON,
        MINNESOTA,
        IDAHO,
        GEORGIA,
        VIRGINIA,
        ILLINOIS,
        GETINSURED
    }
} = configs;


export const assiterNavLinksNames = {
    PENDING_EMP:  'nav_pending_emp',
    ASSISTER_SELF_DELEGATION_TOOL: 'nav_self_delegation_tool_assister',
    PENDING_DELEGATION_REQ: 'nav_pending_delegation_req',
    MY_PROFILE: 'nav_my_profile',
    ADD_NEW_EMP: 'nav_add_new_emp',
    ADD_NEW_IND: 'nav_add_new_indiv',
    START_NEW_APP: 'nav_start_new_app',
    ENROLLER_TOOLKIT: 'nav_enrmnt_counselor',
    MY_DELEGATION: 'delegation_header--2',
    TICKET: 'nav_my_tickets'
};

export const assisterNavLinks = {
    [PENNSYLVANIA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [NEW_MEXICO]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [NEVADA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [NEW_JERSEY]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text:assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [GEORGIA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [MINNESOTA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: (ticketEnabled, isMNFullStack) => ticketEnabled && isMNFullStack
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [IDAHO]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text:assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [VIRGINIA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [ILLINOIS]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [GETINSURED]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: true,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ],
    [OREGON]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: assiterNavLinksNames.PENDING_DELEGATION_REQ,
                    icon: 'clock',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_IND,
                    visibility: true,
                    text: assiterNavLinksNames.PENDING_DELEGATION_REQ

                },
                {
                    name: assiterNavLinksNames.MY_PROFILE,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.ASSISTER_VIEW_PROFILE,
                    visibility: true,
                    text: assiterNavLinksNames.MY_PROFILE
                },
                {
                    name: assiterNavLinksNames.MY_DELEGATION,
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.DELEGATION_OTHER,
                    visibility: true,
                    text: assiterNavLinksNames.MY_DELEGATION
                },
                {
                    name: assiterNavLinksNames.TICKET,
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_TICKET,
                    text: assiterNavLinksNames.TICKET,
                    visibility: ticketEnabled => ticketEnabled
                },
                {
                    name: assiterNavLinksNames.ADD_NEW_IND,
                    icon: 'user',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.BROKER_ADD_NEW_INDIVIDUAL,
                    visibility: addNewIndividualLinkEnabled => addNewIndividualLinkEnabled,
                    text: assiterNavLinksNames.ADD_NEW_IND
                },
            ]
        }

    ]
};
